import * as lottie from 'lottie-web/build/player/lottie';

/**
 * @internal
 */
export class AnimationService {
	public static CreateAnimation(htmlContainer: HTMLElement, animationPath: string, loop: boolean, autoplay: boolean, settings: lottie.SVGRendererConfig | lottie.CanvasRendererConfig | lottie.HTMLRendererConfig): lottie.AnimationItem {
		type LottiePlayer = typeof lottie.default;
		const lottiePlayer = lottie as any as LottiePlayer;
		return lottiePlayer.loadAnimation({
			renderer: 'svg',
			container: htmlContainer,
			loop,
			autoplay,
			path: animationPath,
			rendererSettings: settings
		});
	}
}
